import * as z from "zod";

export const PUBLIC_MCP_PATH = "/v1/mcp";
export const PUBLIC_MCP_OAUTH_SCOPE = "mcp";
export const OAUTH_BASE_PATH = "/v1/oauth";
export const OAUTH_TOKEN_PATH = `${OAUTH_BASE_PATH}/token`;
export const OAUTH_REGISTER_PATH = `${OAUTH_BASE_PATH}/register`;
export const OAUTH_CLIENT_PATH = `${OAUTH_BASE_PATH}/client`;
export const OAUTH_MANAGE_PATH = `${OAUTH_BASE_PATH}/manage`;

export const verifiedOAuthVendorKeySchema = z
  .enum(["chatgpt", "claude", "muse"])
  .describe("VerifiedOAuthVendorKey");

export const oauthClientVerificationSchema = z
  .discriminatedUnion("status", [
    z.object({
      status: z.literal("verified"),
      vendor: z.object({
        key: verifiedOAuthVendorKeySchema,
      }),
    }),
    z.object({ status: z.literal("unverified") }),
  ])
  .describe("OAuthClientVerification");

export const oauthConnectedAppSchema = z
  .object({
    grantId: z.string(),
    name: z.string(),
    redirectHosts: z.array(z.string()),
    verification: oauthClientVerificationSchema,
    connectedAt: z.iso.datetime(),
  })
  .describe("OAuthConnectedApp");

export const findOAuthConnectedAppsOutputSchema = z
  .object({
    apps: z.array(oauthConnectedAppSchema),
    nextCursor: z.string().nullable(),
  })
  .describe("FindOAuthConnectedAppsOutput");

export const revokeOAuthConnectedAppOutputSchema = z
  .object({ success: z.literal(true) })
  .describe("RevokeOAuthConnectedAppOutput");
